import * as Sentry from '@sentry/react'

const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN

// Globals from vite.config.ts define block
declare const __APP_VERSION__: string
declare const __BUILD_NUMBER__: string

export function initSentry() {
  if (!SENTRY_DSN) {
    console.log('[Sentry] DSN not configured, skipping initialization')
    return
  }

  Sentry.init({
    dsn: SENTRY_DSN,
    environment: import.meta.env.MODE,
    release: `utlevering@${__APP_VERSION__}+${__BUILD_NUMBER__}`,
    enabled: import.meta.env.PROD,

    // Sample rate for performance monitoring (0 = disabled, 1 = 100%)
    tracesSampleRate: 0,

    // Only send errors in production
    beforeSend(event) {
      if (import.meta.env.DEV) {
        console.log('[Sentry] Would send event:', event)
        return null
      }
      return event
    },

    // Ignore common non-actionable errors
    ignoreErrors: [
      // Network errors
      'Failed to fetch',
      'NetworkError',
      'Load failed',
      // Browser extensions
      'chrome-extension://',
      'moz-extension://',
      // User aborts
      'AbortError',
      'The operation was aborted',
    ],
  })

  console.log('[Sentry] Initialized for', import.meta.env.MODE)
}

// Re-export ErrorBoundary for use in main.tsx
export const SentryErrorBoundary = Sentry.ErrorBoundary

// Manual error capture for try/catch blocks
export function captureException(error: unknown, context?: Record<string, unknown>) {
  if (context) {
    Sentry.setContext('additional', context)
  }
  Sentry.captureException(error)
}

// Manual message capture for non-error events
export function captureMessage(message: string, level: Sentry.SeverityLevel = 'info') {
  Sentry.captureMessage(message, level)
}
